import dayjs from 'dayjs'
import { useRecordContext, useReference } from 'react-admin'
import { AritcleAuthor } from '../../AritcleAuthor'
import { BlogAuthorProps } from './type'
import { imageUrlConcat } from '../../../utils/url-concat'

export const BlogAuthor: React.FC<BlogAuthorProps> = ({ authorSource, dateSource, ...props }) => {
  const record = useRecordContext()
  const { referenceRecord, isLoading } = useReference({
    reference: 'admins',
    id: record[authorSource],
  })
  const avatarPath = referenceRecord ? imageUrlConcat(referenceRecord?.avatar?.full_path) : ''
  const dateFomatted = record[dateSource] ? dayjs(record[dateSource]).format('D MMMM YYYY') : null
  return (
    !isLoading && (
      <AritcleAuthor
        image={avatarPath}
        name={referenceRecord?.name}
        date={dateFomatted}
        {...props}
      />
    )
  )
}
